export { default } from './SelfReportedPill';
